import { CustomContent } from '@adornis/buildify/db/CustomContent';
import { PageStatus } from '@adornis/buildify/db/enums';
import { css } from '@adornis/chemistry/directives/css';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { DataTable } from '@adornis/data-view/client/table/data-table';
import { View } from '@adornis/data-view/db/view';
import { XDialog } from '@adornis/dialog/x-dialog';
import { webcomponent } from '@adornis/functional-lit/webcomponent';
import type { RouterObject } from '@adornis/router/client/make-router';
import { html } from 'lit';
import { firstValueFrom, timer } from 'rxjs';
import '../../../../client/components/component-icon-button';
import { PublishmentStatusBadge } from '../../../publishment/client/PublishmentStatusBadge';
import { subscribeCustomContents } from '../api/subscribeCustomContents';
import { CustomContentFilter } from '../db/CustomContentFilter';
import { transformStatus } from './TransformStatus';
export const CustomContentsList = webcomponent(
  'custom-contents-list',
  ({ customContentsClass, router }: { customContentsClass: typeof CustomContent; router: RouterObject<'edit'> }) => {
    return html`
      <d-flex space="md">
        <d-button
          ${css({ alignSelf: 'end' })}
          @click=${async () => {
            const createdID = await new customContentsClass({
              name: 'Neuer Custom Content',
              status: PageStatus.IN_PROGRESS,
            }).create();
            router.goTo('edit', { params: { id: createdID } });
          }}
        >
          <d-icon> plus </d-icon>
          Erstellen
        </d-button>
        ${DataTable({
          options: {
            operation: subscribeCustomContents,
            class: customContentsClass,
            view: new View({
              filter: new CustomContentFilter({ customContentClass: customContentsClass._class }),
            }),
            customColumns: [
              {
                customID: 'name',
                columnName: 'Name',
                renderItem: (item: CustomContent) => html`<d-text> ${item.name} </d-text>`,
                selectionSet: {
                  name: 1,
                },
              },
              {
                customID: 'status',
                columnName: 'Status',
                renderItem: (item: CustomContent) =>
                  html`<d-text ${css({ position: 'relative', paddingRight: '16px' })}>
                    ${PublishmentStatusBadge({ published: item.status === PageStatus.PUBLISHED })}
                    ${transformStatus(item.status)}
                  </d-text>`,
                selectionSet: {
                  status: 1,
                },
              },
              {
                customID: 'actions',
                columnName: '',
                columnWidth: '120px',
                renderItem: (item: CustomContent) => html`
                  <d-flex horizontal crossaxis-center space="xs">
                    <d-icon-button
                      solid
                      icon="pencil"
                      @click=${() => {
                        console.log('edit', router);
                        router.goTo('edit', { params: { id: item._id } });
                      }}
                      tooltip="Bearbeiten"
                    ></d-icon-button>
                    <d-icon-button
                      solid
                      icon="trash"
                      @click=${async () => {
                        if (!(await XDialog.confirm('Willst du diesen Custom Content wirklich löschen?'))) return;
                        await XDialog.waitFor(
                          Promise.all([firstValueFrom(timer(1000)), item.remove()]),
                          'Custom Content wird gelöscht...',
                        ).then(() => XSnackbar.show('Erfoglreich gelöscht!'));
                      }}
                      tooltip="Löschen"
                    ></d-icon-button>
                  </d-flex>
                `,
              },
            ],
            loader: () => html`<d-text>Loading...</d-text>`,
            emptyState: () => html`<d-text>Keine Daten gefunden</d-text>`,
          },
        })}
      </d-flex>
    `;
  },
  {
    shadowRoot: true,
  },
);
